import { useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useModal } from '@/providers/modal';
import { PeriodSelectModal } from '@/modals/PeriodSelectModal';
import { MenuList, Option } from './components';
import { getPeriodOptions } from './utils';
import Icon from './icon_chevron.svg';
import s from './index.module.scss';

export const PeriodSelect = ({ range, mobile, onChange }) => {
  const { openSingleModal } = useModal();
  const { t } = useTranslation('reports');
  const options = getPeriodOptions(t);

  const current = useMemo(() => {
    const period = range.join(':');
    return options?.find(option => option.value === period) || null;
  }, [range, options]);

  const handleChange = option => {
    const range = option.value.split(':');
    onChange(range);
  };

  const onClick = () => {
    openSingleModal(MODAL_IDS.period_select_modal);
  };

  if (mobile)
    return (
      <>
        <div className={s.mobile} onClick={onClick}>
          <span className="f-body-regular">{current?.label}</span>
          <img src={Icon} alt="icon" width={20} height={20} />
        </div>
        <PeriodSelectModal range={range} onChange={handleChange} />
      </>
    );

  return (
    <div className={s.wrapper}>
      <div className="f-small-accent">{t('date_picker.period')}</div>
      <Select
        value={current}
        onChange={handleChange}
        className={s.select}
        classNamePrefix="period"
        name="period"
        isSearchable={false}
        options={options}
        components={{ Option, MenuList }}
        placeholder={t('date_picker.custom')}
      />
    </div>
  );
};
